export const base = {
	VUE_APP_BACKEND_BASE_URL: window.location.protocol + '//' + window.location.hostname + '/api/v1/',
	VUE_APP_DISABLE_SENTRY: import.meta.env.VUE_APP_DISABLE_SENTRY,
	APP_SENTRY_RELEASE:  import.meta.env.CI_COMMIT_SHA
};
